/* LANDING DA DESCRIÇÃO — comportamento.
   Markup em snippets/landing-descricao.liquid, estilo em assets/landing-descricao.css.

   1. Abre sozinho o acordeão marcado com data-lp-auto, UMA vez, quando o cabeçalho
      chega a 80% da tela. Usa o próprio clique do tema (CollapsibleBlock + slideAnime).
      Se o cliente abriu ou fechou na mão antes, não mexe mais.
   2. As animações de cada bloco começam quando ele entra na tela (classe lp-vivo).
      Nada nasce escondido: sem JS, a landing aparece parada.
   3. Títulos em Anton encolhem até a linha mais longa caber na coluna. */
(() => {
  const reduz = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1. abrir sozinho ---------- */
  function abrirAoRolar(bloco) {
    const cab = bloco.querySelector('.collapsible-heading');
    const corpo = bloco.querySelector('.collapsible-content');
    if (!cab || !corpo || !('IntersectionObserver' in window)) return;
    cab.addEventListener('click', (e) => { if (e.isTrusted) bloco.dataset.lpMexeu = '1'; });
    const obs = new IntersectionObserver(([e]) => {
      if (!e.isIntersecting) return;
      obs.disconnect();
      if (bloco.dataset.lpMexeu || bloco.classList.contains('active')) return;
      cab.click();
      // O slideAnime do tema ignora o pedido se outra animação estiver rodando,
      // mas a classe "active" muda do mesmo jeito. Confere e acerta.
      setTimeout(() => {
        if (bloco.classList.contains('active') && getComputedStyle(corpo).display === 'none') corpo.style.display = 'block';
      }, 600);
    }, { rootMargin: '0px 0px -20% 0px' });
    obs.observe(cab);
  }
  const autos = document.querySelectorAll('collapsible-block[data-lp-auto]');
  if (autos.length) {
    const comecar = () => autos.forEach(abrirAoRolar);
    window.customElements && customElements.get('collapsible-block') ? comecar()
      : window.customElements ? customElements.whenDefined('collapsible-block').then(comecar) : comecar();
  }

  /* ---------- 3. títulos ---------- */
  function ajustarTitulos(lp) {
    lp.querySelectorAll('.lp-tit').forEach((t) => {
      t.style.fontSize = '';
      const larg = t.clientWidth;
      if (!larg) return;
      let maior = 0;
      t.querySelectorAll(':scope > span').forEach((s) => { maior = Math.max(maior, s.scrollWidth); });
      if (maior > larg) t.style.fontSize = (parseFloat(getComputedStyle(t).fontSize) * larg / maior * 0.97) + 'px';
    });
    const b = lp.querySelector('.lp-tag-versao b');
    if (b) {
      b.style.fontSize = '';
      const selo = b.nextElementSibling;
      const livre = b.parentNode.clientWidth - (selo ? selo.offsetWidth + 10 : 0);
      if (livre > 0 && b.scrollWidth > livre) b.style.fontSize = (parseFloat(getComputedStyle(b).fontSize) * livre / b.scrollWidth * 0.97) + 'px';
    }
  }

  /* ---------- personalização: nomes de exemplo nas costas ---------- */
  function digitar(pers) {
    if (reduz) return;
    const tNome = pers.querySelector('.lp-nome');
    const tNum = pers.querySelector('.lp-num');
    if (!tNome || !tNum) return;
    const nomes = [['SEU NOME', '10'], ['PAI', '7'], ['CRAQUE', '9'], ['SEU NOME', '10']];
    let k = 0;
    const proximo = () => {
      const [nome, num] = nomes[k];
      let i = 0;
      tNome.textContent = '';
      tNum.textContent = '';
      const passo = setInterval(() => {
        tNome.textContent = nome.slice(0, ++i);
        if (i >= nome.length) {
          clearInterval(passo);
          setTimeout(() => { tNum.textContent = num; }, 220);
          if (++k < nomes.length) setTimeout(proximo, 2400);
        }
      }, 110);
    };
    setTimeout(proximo, 500);
  }

  /* ---------- torcedor x jogador ---------- */
  function comoVeste(lp) {
    const palco = lp.querySelector('.lp-palco');
    if (!palco) return;
    const txt = lp.querySelector('[data-lp-veste-txt]');
    const rot = lp.querySelector('[data-lp-veste-rot]');
    const textos = {
      torcedor: ['Corte solto', '<b>Corte mais solto</b>, pensado para o estádio e para o dia a dia. Confira suas medidas na tabela antes de escolher.'],
      jogador: ['Corte ajustado', '<b>Corte ajustado ao corpo</b> e tecido mais leve, como a usada em campo. Costuma vestir menor: na dúvida entre dois tamanhos, fique com o maior.']
    };
    lp.querySelectorAll('[data-lp-versao]').forEach((b) => b.addEventListener('click', () => {
      const v = b.dataset.lpVersao;
      lp.querySelectorAll('[data-lp-versao]').forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
      palco.classList.toggle('is-jogador', v === 'jogador');
      ['torcedor', 'jogador'].forEach((n) => {
        const el = palco.querySelector('[data-lp-silh="' + n + '"]');
        el.classList.toggle('is-on', n === v);
        el.classList.remove('is-desenha');
        if (n === v && !reduz) { void el.getBoundingClientRect(); el.classList.add('is-desenha'); }
      });
      const ativo = palco.querySelector('[data-lp-silh="' + v + '"]');
      ativo.parentNode.insertBefore(ativo, palco.querySelector('.lp-medida'));
      rot.innerHTML = '<small>Caimento</small>' + textos[v][0];
      txt.innerHTML = textos[v][1];
    }));
    // a tabela de medidas é o modal do snippet tabela-medidas; sem ele, o botão some
    const btn = lp.querySelector('[data-lp-tabela]');
    if (btn) {
      const abrir = document.querySelector('[data-tm-abrir]');
      if (!abrir) btn.hidden = true;
      else btn.addEventListener('click', () => abrir.click());
    }
  }

  /* ---------- "Olha o acabamento" em sequência ---------- */
  function sequencia(lp) {
    const fig = lp.querySelector('[data-lp-slides]');
    if (!fig) return;
    const slides = [...fig.querySelectorAll('.lp-slide')];
    if (slides.length < 2) return;
    const barras = [...fig.querySelectorAll('.lp-prog i')];
    const DUR = 4500;
    fig.style.setProperty('--lp-dur', DUR + 'ms');
    let atual = 0, timer = null, visivel = false;
    const agendar = () => {
      clearTimeout(timer);
      fig.style.setProperty('--lp-play', visivel && !reduz ? 'running' : 'paused');
      if (visivel && !reduz) timer = setTimeout(() => mostrar(atual + 1), DUR);
    };
    function mostrar(n) {
      atual = (n + slides.length) % slides.length;
      slides.forEach((el, i) => { el.classList.toggle('is-ativo', i === atual); el.setAttribute('aria-hidden', String(i !== atual)); });
      barras.forEach((b, i) => {
        b.classList.toggle('is-feito', i < atual);
        b.classList.remove('is-agora');
        if (i === atual) { void b.offsetWidth; b.classList.add('is-agora'); }
      });
      agendar();
    }
    fig.querySelector('.lp-slide-nav--ant').addEventListener('click', () => mostrar(atual - 1));
    fig.querySelector('.lp-slide-nav--prox').addEventListener('click', () => mostrar(atual + 1));
    let x0 = null;
    fig.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
    fig.addEventListener('touchend', (e) => {
      if (x0 === null) return;
      const dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) mostrar(atual + (dx < 0 ? 1 : -1));
      x0 = null;
    }, { passive: true });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(([e]) => { visivel = e.isIntersecting; if (visivel) mostrar(atual); else agendar(); }, { threshold: 0.4 }).observe(fig);
    }
  }

  /* ---------- montar cada landing ---------- */
  function iniciar(lp) {
    if (lp.dataset.lpPronto) return;
    lp.dataset.lpPronto = '1';

    if ('ResizeObserver' in window) new ResizeObserver(() => ajustarTitulos(lp)).observe(lp);
    else window.addEventListener('resize', () => ajustarTitulos(lp));
    if (document.fonts) document.fonts.ready.then(() => ajustarTitulos(lp));

    comoVeste(lp);
    sequencia(lp);

    // mural: a segunda cópia de cada faixa existe só para o laço não ter emenda
    const vivos = lp.querySelectorAll('[data-lp-vivo]');
    if ('IntersectionObserver' in window) {
      const obs = new IntersectionObserver((es) => es.forEach((e) => {
        if (e.target.classList.contains('lp-recebidos')) {
          e.target.classList.toggle('is-visivel', e.isIntersecting);
          // o mural desliza: a foto que está à direita, fora da tela, precisa chegar antes de entrar
          if (e.isIntersecting) e.target.querySelectorAll('.lp-rec img[loading="lazy"]').forEach((img) => { img.loading = 'eager'; });
        }
        if (e.isIntersecting && !e.target.classList.contains('lp-vivo')) {
          e.target.classList.add('lp-vivo');
          if (e.target.classList.contains('lp-pers')) digitar(e.target);
        }
      }), { threshold: 0.25 });
      vivos.forEach((s) => obs.observe(s));
    }

    lp.addEventListener('click', (ev) => {
      const a = ev.target.closest('[data-lp-rolar]');
      if (!a) return;
      const alvo = document.querySelector(a.dataset.lpRolar);
      if (!alvo) return;
      ev.preventDefault();
      alvo.scrollIntoView({ behavior: reduz ? 'auto' : 'smooth', block: 'center' });
    });
  }
  document.querySelectorAll('.lp').forEach(iniciar);
})();
